/*
    Table module
*/
import cloneDeep from 'lodash/cloneDeep';
import tableConfigBuilder from './table-config-builder';
import { tableTooltip } from '../widget-utilities/widget-tooltip';
import d3Utils from '../../../utils/d3Utils';
import chartUtils from '../../../utils/chart-utils';
import tadaWidgetFunctions from '../../../widgetFunctions/index';

var table = function table() {

    // Render table widget
    var renderWidget = function renderWidget(widgetConfig) {
        var Id = widgetConfig.Id,
            ContainerId = widgetConfig.ContainerId,
            Model = widgetConfig.Model,
            Cloud = widgetConfig.Cloud,
            TableConfig = widgetConfig.TableConfig,
            StampText = widgetConfig.StampText,
            Data = widgetConfig.Data,
            ServiceName = widgetConfig.ServiceName;


        var id = Id;
        var tableId = chartUtils.replaceAll(id, ' ', '');
        var el = window.document.querySelector('#' + ContainerId);
        var modelName = Model;
        var cloudName = Cloud;
        var crumbFormat = {
            "CloudName": cloudName,
            "ModelName": modelName,
            "Type": "Node",
            "Name": "",
            "FieldName": "",
            "Value": ""
        };

        var pageIndex = TableConfig.PageNumber;
        var pageSize = TableConfig.PageSize;
        var maxPageSize = TableConfig.MaxPageSize.toString();
        var isEditable = TableConfig.IsEditable;
        var serviceName = ServiceName;
        var fields = TableConfig.Fields;
        var pivotFieldConfig = TableConfig.PivotFieldConfig;
        var classifier = TableConfig.ClassifierField;
        var setValueAsClass = TableConfig.SetCellValueAsClass;
        var containerClassName = TableConfig.ContainerClassName;
        var sortOrders = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.sortOrders), '\x01', ""));
        var stampText = StampText;
        var groupedRows = TableConfig.GroupedRows;
        var pageCount = Data.pageCount;
        var totalRowCount = Data.totalRowCount;

        var topPerformersCount = TableConfig.TopPerformersCount;
        var bottomPerformersCount = TableConfig.BottomPerformersCount;
        var accumulator = [];

        var data = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.data), '\x01', ""));
        var pivotColumnData = JSON.parse(chartUtils.replaceAll(JSON.stringify(Data.pivotColumnData), '\x01', ""));

        var aggregates = {};
        var pivotColumnAggregates = {};

        if (Data.aggregates != null) aggregates = JSON.parse(Data.aggregates);
        if (Data.pivotColumnAggregates != null) pivotColumnAggregates = JSON.parse(Data.pivotColumnAggregates);
        if (pageCount != null) pageCount = Number(pageCount);
        if (pageIndex != null) pageIndex = Number(pageIndex);
        if (pageSize != null) pageSize = Number(pageSize);
        if (maxPageSize != null) maxPageSize = Number(maxPageSize);
        if (totalRowCount != null) totalRowCount = Number(totalRowCount);

        if (setValueAsClass == null || setValueAsClass.toString().trim().length == 0) setValueAsClass = false;else {
            if (setValueAsClass.toString().toLowerCase() == "true") setValueAsClass = true;else setValueAsClass = false;
        }

        if (containerClassName != null && containerClassName.toString().trim().length == 0) containerClassName = null;

        var headers = [];
        if ((fields == null || fields.length == 0) && pivotFieldConfig == null) {
            fields = [];
            var hdrs = Object.keys(data[0]);

            hdrs.forEach(function (n, i) {
                var fieldSeries = { HeaderName: n, FieldName: n, Justification: chartUtils.textJustification.none };
                fields.push(fieldSeries);
            });
        }

        var hasConditionals = false;
        if (fields != null) {
            for (var index = 0; index < fields.length; index++) {
                if (fields[index].ConditionalFormatting == null || fields[index].ConditionalFormatting.length < 1) continue;

                hasConditionals = true;
                break;
            }
        }

        if (pivotFieldConfig != null) {
            if (pivotFieldConfig.ValueFields != null) for (var index = 0; index < pivotFieldConfig.ValueFields.length; index++) {
                if (pivotFieldConfig.ValueFields[index].ConditionalFormatting == null || pivotFieldConfig.ValueFields[index].ConditionalFormatting.length < 1) continue;
                hasConditionals = true;
                break;
            }
        }

        var fieldToHeaderMappingConditional = {};
        if (fields != null && fields.length > 0) {
            var fieldsLength = fields.length;
            for (var fieldIndex = 0; fieldIndex < fieldsLength; fieldIndex++) {
                if (fields[fieldIndex].AggregationType == null) continue;
                if (fields[fieldIndex].AggregationType.toLowerCase() != "unknown") continue;
                fieldToHeaderMappingConditional[fields[fieldIndex].FieldName] = fields[fieldIndex].HeaderName;
            }
        }

        var tooltipText = "";
        accumulator = data;
        for (var i = 0; i < accumulator.length; i++) {
            var d = accumulator[i];
            if (fields != null) {
                for (var index = 0; index < fields.length; index++) {
                    var f = fields[index];
                    var tooltip = f.Tooltip;

                    if (tooltip != null && tooltip.TooltipConfigs.length > 0) {
                        var tooltipConfigs = tooltip.TooltipConfigs;
                        for (var tipIndex = 0; tipIndex < tooltipConfigs.length; tipIndex++) {
                            var tipItem = tooltipConfigs[tipIndex];

                            var tipvalue = chartUtils.getTooltipValue(tipItem, d);

                            if (tipItem.TipField == f.FieldName && tipItem.AggregationType == "") tipValue = d[f.FieldName];

                            d[tipItem.Id] = tipvalue;
                        }
                    }
                }
            }
        }

        var rowHeaders = [];
        if (fields != null) {
            for (var index = 0; index < fields.length; index++) {
                var f = fields[index];
                if (f.FieldName == null || f.FieldName.toString().trim().length == 0 || pivotFieldConfig != null && f.FieldName.toString().trim() == pivotFieldConfig.CategoryField || pivotFieldConfig != null && f.FieldName.toString().trim() == pivotFieldConfig.ValueField) continue;

                rowHeaders.push(fields[index]);
                var headerField = { fieldName: f.FieldName.toString(), headerName: fields[index].HeaderName, isHidden: f.IsHidden };
                headers.push(headerField);
            }
        }

        if (pivotFieldConfig != null && pivotColumnData != null) {
            //Added sort logic and will be removed after implementing Date datatype Sort properly.
            var inverseSort = pivotFieldConfig.Sort == chartUtils.sortType.descending;

            if (pivotFieldConfig.CategoryDateFormat != null && pivotFieldConfig.CategoryDateFormat.length > 0) {
                chartUtils.sort(pivotColumnData, pivotFieldConfig.CategoryField, pivotFieldConfig.CategoryField, inverseSort);
            }

            if (pivotFieldConfig.ShowRowHeaders) {
                var headerField = { fieldName: "pivotField", headerName: "" };
                headers.push(headerField);
            }

            for (var index = 0; index < pivotColumnData.length; index++) {
                var pivotItem = pivotColumnData[index];

                var headerValue = pivotItem[pivotFieldConfig.CategoryField];

                var originalValue = pivotItem[pivotFieldConfig.CategoryField];

                if (pivotFieldConfig.CategoryDateFormat != null && pivotFieldConfig.CategoryDateFormat != "") headerValue = chartUtils.formatDate(headerValue, pivotFieldConfig.CategoryDateFormat);

                var headerField = { value: originalValue, fieldName: "pivotField", headerName: headerValue };
                headers.push(headerField);
            }

            if (pivotFieldConfig.ShowRowHeaders) {
                var tempPivotColumn = {};
                tempPivotColumn[pivotFieldConfig.CategoryField] = "Series";
                pivotColumnData.unshift(tempPivotColumn);
            }
        }

        if (isEditable) {
            var editHeader = { fieldName: "editHeader", headerName: "" };
            headers.push(editHeader);
        }

        var tempAccumulator = [];

        if (topPerformersCount > 0) for (var i = 0; i < topPerformersCount; i++) {
            tempAccumulator.push(accumulator[i]);
        }if (bottomPerformersCount > 0) for (var i = 0; i < bottomPerformersCount; i++) {
            tempAccumulator.push(accumulator[accumulator.length - 1 - i]);
        }if (tempAccumulator.length > 0) accumulator = tempAccumulator;

        var tableContainer = window.document.createElement("div");
        tableContainer.setAttribute("style", "width:100%;height:92%;overflow:auto;");
        tableContainer.setAttribute("id", tableId + "Container");

        var className = "visor-table-container";

        if (containerClassName != null) className += " " + containerClassName;

        tableContainer.setAttribute("class", className);

        var table = window.document.createElement("table");

        if (groupedRows) table.setAttribute("class", "visor-table blocks-table");else table.setAttribute("class", "visor-table");

        table.setAttribute("id", tableId);

        var thead = window.document.createElement("thead");

        thead.setAttribute("id", tableId + "Headers");

        var headerRow = window.document.createElement("tr");

        for (var i = 0; i < headers.length; i++) {
            var th = window.document.createElement("th");
            var header = headers[i];
            var className = "table-header";
            th.innerHTML = header.headerName + "&nbsp;";
            th.setAttribute("fieldName", header.fieldName);
            th.setAttribute("value", header.value);
            var hidden = header.isHidden;
            if (hidden == null) hidden = false;

            if (hidden) className += " hidden";

            th.setAttribute("class", className);
            th.setAttribute("style", "position: sticky; top: 0;");

            if (sortOrders != null) {
                var sortOrderKeys = Object.keys(sortOrders);
                for (var key in sortOrders) {
                    if (key != header.headerName) continue;

                    var direction = sortOrders[key];

                    if (isTemporalField(header.fieldName)) {
                        var inversesort = direction != chartUtils.sortType.ascending;
                        chartUtils.compoundSort(accumulator, sortOrderKeys, sortOrders, false);
                    }
                    var sortElement = window.document.createElement('i');
                    if (direction.toString().toLowerCase() == "ascending" || direction.toString().toLowerCase() == "a") sortElement.setAttribute("class", "fa fa-caret-up fa-lg");else sortElement.setAttribute("class", "fa fa-caret-down fa-lg");

                    th.setAttribute("sorted", "true");
                    th.setAttribute("sortMode", "" + direction + "");
                    th.appendChild(sortElement);
                }
            }

            headerRow.appendChild(th);
        }

        if (pivotFieldConfig != null) {
            var rowTotalFields = pivotFieldConfig.ValueFields.find(function (field) {
                return field.ShowTotal === true;
            });

            if (rowTotalFields) {
                var totalheader = window.document.createElement("th");
                totalheader.innerHTML = "Total";
                totalheader.setAttribute("class", "table-header");
                headerRow.appendChild(totalheader);
            }
        }

        thead.appendChild(headerRow);

        table.appendChild(thead);

        var tbody = window.document.createElement("tbody");

        tbody.setAttribute("id", tableId + "Content");

        if (classifier != null && classifier.toString().trim().length == 0) classifier = null;

        var addedParentValues = [];
        var fieldTotals = {};
        var pivotTotals = {};
        var pivotRowTotal = {};
        var propertyFields = fields.filter(function (field) {
            return field.PropertyType.toLowerCase() === "property";
        }).map(function (field) {
            return {
                id: field.Id,
                name: accumulator[0].hasOwnProperty(field.FieldName) ? field.FieldName : field.HeaderName
            };
        });

        for (var i = 0; i < accumulator.length; i++) {
            var d = accumulator[i];
            var tr = window.document.createElement("tr");
            var trClass = "";
            var emptyRowAdded = false;

            if (classifier != null) trClass += d[classifier];

            if (hasConditionals) {
                trClass += "hasConditionals";
            }

            if (fields != null) {
                for (var j = 0; j < fields.length; j++) {
                    var f = fields[j];

                    if (f.FieldName == null || f.FieldName.toString().trim().length == 0 || pivotFieldConfig != null && f.FieldName.toString().trim() == pivotFieldConfig.CategoryField || pivotFieldConfig != null && f.FieldName.toString().trim() == pivotFieldConfig.ValueField) continue;

                    var td = window.document.createElement("td");
                    var tdStyle = "";
                    var className = "";

                    if (f.StyleName != null) className += f.StyleName + " ";

                    var displayText = "";
                    var justification = f.Justification;
                    if (f.PropertyType.toLowerCase() === "property") {
                        if (d.hasOwnProperty(f.HeaderName)) displayText = d[f.HeaderName];else displayText = d[f.FieldName];
                    } else {
                        displayText = tadaWidgetFunctions.calculateWidgetFunction(d, f.WidgetFunction, propertyFields);
                    }

                    if (f.HasChild) {
                        var item = chartUtils.findValue(addedParentValues, f.FieldName, displayText);
                        if (item != null) {
                            item["rowSpan"] = item["rowSpan"] + 1;
                            tdStyle += "display:none;";
                            var parentTd = item["parentTd"];
                            parentTd.setAttribute("rowSpan", item["rowSpan"]);
                        } else {
                            if (!emptyRowAdded && groupedRows && j < 1) {
                                var emptyRow = window.document.createElement("tr");
                                emptyRow.setAttribute("class", "haschildren");
                                tbody.appendChild(emptyRow);
                                emptyRowAdded = true;
                                className += "block-td";
                            }
                            item = {};
                            item["FieldName"] = f.FieldName;
                            item[f.FieldName] = displayText;
                            item["rowSpan"] = 1;
                            item["parentTd"] = td;
                            addedParentValues.push(item);
                        }
                    }

                    if (!f.HasChild && (displayText == null || displayText.toString().trim().length == 0) && d[f.HeaderName] != null && d[f.HeaderName].toString().trim().length > 0) displayText = d[f.HeaderName];

                    td.innerHTML = chartUtils.format(displayText, f.DisplayFormat, f.CurrencySymbol, null, f.BaseFormat, null, f.FieldName);

                    if (f.Justification == chartUtils.textJustification.none) {
                        if (isNumber(td.innerHTML)) justification = chartUtils.textJustification.right;else justification = chartUtils.textJustification.left;
                    }

                    tdStyle += "text-align:" + justification + ";";
                    if (TableConfig.IsFreeze && j == 0) tdStyle += "position: sticky; left:0; border-collapse: separate; background-color: white;";

                    if (f.IsHidden) className += " hidden";

                    td.setAttribute("class", "dataviz editrow " + className);
                    td.setAttribute("value", displayText);
                    td.setAttribute("style", tdStyle);
                    td.setAttribute("fieldName", f.FieldName);
                    td.setAttribute("seriesidentifier", f.FieldName);
                    td.addEventListener("touchstart", function (e) {
                        tableTooltip.onMouseOver.call(this, e);
                    });
                    td.addEventListener("mouseover", function (e) {
                        tableTooltip.onMouseOver.call(this, e);
                    });
                    td.addEventListener("mouseout", function () {
                        tableTooltip.onMouseOut();
                    });
                    td.addEventListener("touchmove", function () {
                        tableTooltip.onTouchMove();
                    });
                    td.addEventListener("mousemove", function (e) {
                        tableTooltip.onMouseMove.call(this, e);
                    });

                    var tooltipText = '';
                    var tooltip = f.Tooltip;

                    if (tooltip != null && tooltip.TooltipConfigs.length > 0 && displayText != null) {
                        tooltipText = tooltip.TooltipText;

                        for (var tipIndex = 0; tipIndex < tooltip.TooltipConfigs.length; tipIndex++) {
                            var tipItem = tooltip.TooltipConfigs[tipIndex];

                            var tipValue = d[tipItem.Id];

                            if (tipValue == null || tipValue == "--") {

                                var field = fields.find(function (element) {
                                    return element.FieldName == tipItem.TipField;
                                });

                                if (field != null) tipValue = d[field.HeaderName];
                            }

                            if (tipValue != null && tipValue.toString().trim().length > 0) tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);

                            if (tipValue == null || tipValue.trim().length == 0) tipValue = "--";

                            tooltipText = tooltipText.replace("{" + tipItem.TipField + "}", tipValue + " ");
                        }
                    }
                    if (tooltipText != "") td.setAttribute("label", tooltipText);

                    if (f.ConditionalFormatting != null && f.ConditionalFormatting.length > 0) {
                        applyConditionalFormatting(f, td, displayText, d);
                    }

                    if (f.HyperlinkProperty && td != null && td.innerText.length > 0) td.innerHTML = '<a style="color: #0000C4" class="table-hyper-link" href="' + td.innerText + '"><u>' + (f.HyperLinkDisplayText.length > 0 ? f.HyperLinkDisplayText : d[f.HyperlinkDisplayProperty]) + '</u><i style="display: inline; color:#000000;" class="fa fa-external-link"></i></a>';else if (f.IsHyperlink && f.HyperlinkUrl.length > 0 && td != null && td.innerText.length > 0) td.innerHTML = '<a style="color: #0000C4" class="table-hyper-link" href="' + f.HyperlinkUrl + td.innerText + '"><u>' + (f.HyperLinkDisplayText.length > 0 ? f.HyperLinkDisplayText : d[f.HyperlinkDisplayProperty]) + '</u><i style="display: inline; color:#000000;" class="fa fa-external-link"></i></a>';

                    if ((f.AggregationType == null || f.AggregationType == chartUtils.aggregationTypes.unknown) && f.CrumbMetaName != null && f.CrumbFieldName != null) {
                        var crumb = crumbFormat;
                        crumb.Name = f.CrumbMetaName;
                        crumb.FieldName = f.CrumbFieldName;
                        crumb.Value = d[f.CrumbHeaderName];

                        crumb.DisplayFieldName = f.CrumbDisplayFieldName;
                        crumb.DisplayValue = d[f.CrumbDisplayHeaderName];
                        crumb.DefaultPerspective = f.DefaultPerspective;

                        td.setAttribute("coord", JSON.stringify(crumb));
                    }

                    if (f.LabelFieldName != null && d["label"] != null && d[f.FieldName] != null) td.setAttribute("label", d["label"]);

                    if (f.ShowTotal) {
                        if (!fieldTotals[f.HeaderName]) fieldTotals[f.HeaderName] = 0;

                        fieldTotals[f.HeaderName] += Number(d[f.HeaderName]);
                    }

                    tr.appendChild(td);
                }
            }

            if (pivotFieldConfig != null && pivotColumnData != null) {
                for (var index = 0; index < pivotColumnData.length; index++) {
                    var pivotItem = pivotColumnData[index];
                    var pivotSeries = chartUtils.findValue(pivotFieldConfig.ValueFields, 'HeaderName', d.Series);

                    var td = window.document.createElement("td");
                    var className = "";
                    var displayText = "";
                    var justification = pivotSeries.Justification;

                    displayText = d[pivotItem[pivotFieldConfig.CategoryField]][pivotSeries.HeaderName];

                    if (displayText == null) displayText = d[pivotItem[pivotFieldConfig.CategoryField]][pivotSeries.FieldName];

                    if (pivotItem.HasChild) if (chartUtils.inArray(addedParentValues, displayText)) displayText = "";else addedParentValues.push(displayText);

                    td.innerHTML = chartUtils.format(displayText, pivotSeries.DisplayFormat, pivotSeries.CurrencySymbol, null, pivotSeries.BaseFormat, null, pivotSeries.FieldName);

                    if (pivotSeries.Justification == chartUtils.textJustification.none) {
                        if (isNumber(td.innerHTML)) justification = chartUtils.textJustification.right;else justification = chartUtils.textJustification.left;
                    }

                    td.setAttribute("class", "dataviz editrow " + className);
                    td.setAttribute("value", displayText);
                    td.setAttribute("style", "text-align:" + justification + "");
                    td.setAttribute("seriesidentifier", "pivotedColumn_" + pivotSeries.FieldName);

                    var tooltip = pivotSeries.Tooltip;

                    var tooltipText = '';

                    if (tooltip != null && tooltip.TooltipConfigs.length > 0 && displayText != null) {
                        tooltipText = tooltip.TooltipText;

                        for (var tipIndex = 0; tipIndex < tooltip.TooltipConfigs.length; tipIndex++) {
                            var tipItem = tooltip.TooltipConfigs[tipIndex];

                            var tipValue = d[tipItem.Id];

                            if (tipValue == null) tipValue = d[tipItem.TipField];
                            if (tipItem.TipField == pivotFieldConfig.CategoryField) tipValue = pivotItem[pivotFieldConfig.CategoryField];

                            if (tipItem.TipField == pivotFieldConfig.ValueField) tipValue = d[pivotItem[pivotFieldConfig.CategoryField]];

                            if (tipValue != null && tipValue.toString().trim().length > 0) tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false);

                            if (tipValue == null || tipValue.length == 0 || tipValue == "") tipValue = "--";

                            tooltipText = tooltipText.replace("{" + tipItem.TipField + "}", tipValue + " ");
                        }
                    }

                    if (tooltipText != null && tooltipText.trim().length > 0) td.setAttribute("label", tooltipText);

                    if (pivotFieldConfig.CrumbMetaName != null && pivotFieldConfig.CrumbFieldName != null) {
                        var crumb = crumbFormat;
                        crumb.Name = pivotFieldConfig.CrumbMetaName;
                        crumb.FieldName = pivotFieldConfig.CategoryField;
                        crumb.Value = pivotItem[pivotFieldConfig.CategoryField];
                        crumb.DisplayFieldName = pivotFieldConfig.CategoryField;
                        crumb.DisplayValue = pivotItem[pivotFieldConfig.CategoryField];
                        crumb.DefaultPerspective = pivotFieldConfig.DefaultPerspective;

                        td.setAttribute("coord", JSON.stringify(crumb));
                    }

                    if (pivotSeries.ConditionalFormatting != null && pivotSeries.ConditionalFormatting.length > 0 && pivotItem[pivotFieldConfig.CategoryField] != "Series") {
                        applyConditionalFormatting(pivotSeries, td, displayText, d, pivotFieldConfig.CategoryField, pivotItem);
                    }

                    tr.appendChild(td);

                    if (pivotFieldConfig.ShowColumnTotal) {
                        if (!pivotTotals[pivotItem[pivotFieldConfig.CategoryField]]) pivotTotals[pivotItem[pivotFieldConfig.CategoryField]] = 0;

                        pivotTotals[pivotItem[pivotFieldConfig.CategoryField]] += Number(d[pivotItem[pivotFieldConfig.CategoryField]][pivotSeries.HeaderName]);
                    }

                    if (pivotSeries.ShowTotal) {
                        if (!pivotRowTotal[i]) pivotRowTotal[i] = 0;

                        pivotRowTotal[i] += Number(d[pivotItem[pivotFieldConfig.CategoryField]][pivotSeries.HeaderName]);
                    }
                }
            }

            tr.setAttribute("class", trClass);
            if (isEditable) {
                var td = window.document.createElement('td');
                td.innerHTML = "<i class='fa fa-pencil-square-o'></i>";
                td.setAttribute("class", "dataEditor-trigger");
                td.setAttribute("tableEditor", "0");
                td.setAttribute("serviceName", serviceName);
                tr.appendChild(td);
            }

            if (Object.keys(pivotRowTotal).length > 0) {
                var totalCell = window.document.createElement("td");
                totalCell.innerHTML = chartUtils.format(pivotRowTotal[i], pivotSeries.DisplayFormat, pivotSeries.CurrencySymbol, null, pivotSeries.BaseFormat, null, pivotSeries.FieldName);
                tr.appendChild(totalCell);
            }

            tbody.appendChild(tr);
        }

        if (aggregates != null && Object.keys(aggregates).length > 0) {
            var newTotals = {};
            Object.keys(aggregates).forEach(function (key) {
                var field = fields.find(function (x) {
                    return x.HeaderName + "_Sum" === key;
                });
                aggregates[key] = chartUtils.format(aggregates[key], field.DisplayFormat, field.CurrencySymbol, null, field.BaseFormat, null, field.FieldName);

                newTotals[field.HeaderName] = aggregates[key];
            });
            appendTotal(newTotals);
        } else if (Object.keys(fieldTotals).length > 0) {
            Object.keys(fieldTotals).forEach(function (key) {
                var field = fields.find(function (x) {
                    return x.HeaderName === key;
                });
                fieldTotals[key] = chartUtils.format(fieldTotals[key], field.DisplayFormat, field.CurrencySymbol, null, field.BaseFormat, null, field.FieldName);
            });
            appendTotal(fieldTotals);
        }

        if (pivotColumnAggregates != null && Object.keys(pivotColumnAggregates).length > 0) {
            var newPivotTotals = {};
            Object.keys(pivotColumnAggregates).forEach(function (key) {
                var splitKey = key.split("_")[0];
                pivotColumnAggregates[key] = chartUtils.format(pivotColumnAggregates[key], pivotSeries.DisplayFormat, pivotSeries.CurrencySymbol, null, pivotSeries.BaseFormat, null, pivotSeries.FieldName);

                newPivotTotals[splitKey] = pivotColumnAggregates[key];
            });
            appendTotal(newPivotTotals);
        } else if (Object.keys(pivotTotals).length > 0) {
            Object.keys(pivotTotals).forEach(function (key) {
                pivotTotals[key] = chartUtils.format(pivotTotals[key], pivotSeries.DisplayFormat, pivotSeries.CurrencySymbol, null, pivotSeries.BaseFormat, null, pivotSeries.FieldName);
            });
            appendTotal(pivotTotals);
        }

        function appendTotal(Totals) {
            var totalRow = $(tbody).find(".table-total")[0];
            if (!totalRow) {
                totalRow = window.document.createElement("tr");
                totalRow.setAttribute("class", "table-total");
            }

            for (var total in Totals) {
                var columnIndex = $(headerRow).find("th:contains('" + total + "')").index();
                if (columnIndex < 0) continue;

                var td = window.document.createElement("td");
                td.setAttribute("class", "dataviz");
                td.setAttribute("style", "text-align: center;font-weight: bold;background-color: #fff;color: #000");
                td.innerHTML = Totals[total];

                while (totalRow.cells.length < columnIndex) {
                    var tblData = window.document.createElement("td");
                    tblData.setAttribute("class", "dataviz ");
                    tblData.setAttribute("style", "text-align: center;font-weight: bold;background-color: #fff;color: #000");
                    if (totalRow.cells.length === 0) tblData.innerHTML = "Totals";

                    totalRow.appendChild(tblData);
                    if ($(headerRow).find("th")[totalRow.cells.length - 1].classList.contains("hidden")) totalRow.cells[totalRow.cells.length - 1].setAttribute("class", "dataviz hidden");
                }

                if (totalRow.cells.length > columnIndex) totalRow.cells[columnIndex].innerText = Totals[total];else totalRow.appendChild(td);
            }
            tbody.appendChild(totalRow);
        }

        table.appendChild(tbody);

        tableContainer.appendChild(table);

        el.appendChild(tableContainer);

        if (stampText != null && stampText.trim().length > 0) {

            var stamp = window.document.createElement("p");
            stamp.setAttribute("class", "stampText");
            stamp.innerHTML = stampText;
            var stampTextContainer = window.document.createElement("div");
            stampTextContainer.setAttribute("class", "stampTextContainer");
            stampTextContainer.appendChild(stamp);
            tableContainer.appendChild(stampTextContainer);
        }

        /*Pagination UI*/
        applyPagination();

        function applyPagination() {
            var pageContainer = window.document.createElement("div");
            pageContainer.setAttribute("style", "width:100%;");

            var className = "table-page-container";

            if (containerClassName != null) className += " " + containerClassName;

            pageContainer.setAttribute("class", className);
            el.appendChild(pageContainer);

            var pagingHostcontainer = window.document.createElement('div');
            pagingHostcontainer.setAttribute("class", "paging-host");
            pageContainer.appendChild(pagingHostcontainer);

            var textPagingContainer = window.document.createElement("div");
            textPagingContainer.setAttribute("class", "textPagination");
            textPagingContainer.setAttribute("style", "float:left");

            var showingLabel = window.document.createElement("label");
            showingLabel.innerHTML = "Page ";
            textPagingContainer.appendChild(showingLabel);

            var pageInput = window.document.createElement("input");
            pageInput.setAttribute("value", pageIndex);
            pageInput.setAttribute("class", "page-count-input");
            pageInput.setAttribute("pageCount", pageCount == 0 ? 1 : pageCount);
            textPagingContainer.appendChild(pageInput);

            var pageCountLabel = window.document.createElement("label");
            var formattedPageCount = chartUtils.format(pageCount, ",.0f");
            pageCountLabel.innerHTML = " of " + (pageCount == 0 ? 1 : formattedPageCount);
            textPagingContainer.appendChild(pageCountLabel);

            pagingHostcontainer.appendChild(textPagingContainer);

            var pagingContainer = window.document.createElement("div");
            pagingContainer.setAttribute("class", "pagination");

            var pagingStartingSymbol = window.document.createElement('a');
            pagingStartingSymbol.setAttribute("href", "#");
            pagingStartingSymbol.setAttribute("pageIndex", "1");
            pagingStartingSymbol.innerHTML = "First";
            pagingContainer.appendChild(pagingStartingSymbol);

            var pagingPrevSymbol = window.document.createElement('a');
            pagingPrevSymbol.setAttribute("href", "#");
            pagingPrevSymbol.setAttribute("pageIndex", "prev");
            pagingPrevSymbol.innerHTML = "&laquo;";
            pagingContainer.appendChild(pagingPrevSymbol);

            var showPageCount = pageIndex + 3 > pageCount ? pageCount : pageIndex + 3;

            var showPageIndex = pageIndex - 2 < 1 ? 1 : pageIndex - 2;

            for (var i = showPageIndex; i <= showPageCount; i++) {
                var page = window.document.createElement('a');
                page.setAttribute("href", "#");
                page.setAttribute("pageIndex", i);
                page.innerHTML = i;
                if (i == pageIndex) page.setAttribute("class", "active");
                pagingContainer.appendChild(page);
            }

            var pagingNextSymbol = window.document.createElement('a');
            pagingNextSymbol.setAttribute("href", "#");
            pagingNextSymbol.setAttribute("pageIndex", "next");
            pagingNextSymbol.innerHTML = "&raquo;";
            pagingContainer.appendChild(pagingNextSymbol);

            var pagingFinishSymbol = window.document.createElement('a');
            pagingFinishSymbol.setAttribute("href", "#");
            pagingFinishSymbol.setAttribute("pageIndex", pageCount);
            pagingFinishSymbol.innerHTML = "Last";
            pagingContainer.appendChild(pagingFinishSymbol);

            pagingHostcontainer.appendChild(pagingContainer);

            var pageSizeContainer = window.document.createElement('div');
            pageSizeContainer.setAttribute("class", "page-size");
            pagingHostcontainer.appendChild(pageSizeContainer);

            var pageSizeLabel = window.document.createElement("label");
            pageSizeLabel.innerHTML = "Page Size ";
            pageSizeContainer.appendChild(pageSizeLabel);

            var pageSizeInput = window.document.createElement('input');
            var formattedTotalRow = chartUtils.format(totalRowCount, ",.0f");
            var formattedPageSize = chartUtils.format(pageSize, ",.0f");
            pageSizeInput.setAttribute("value", pageSize > totalRowCount ? totalRowCount : pageSize);
            pageSizeInput.setAttribute("max", maxPageSize);
            pageSizeInput.setAttribute("class", "page-size-input");
            pageSizeContainer.appendChild(pageSizeInput);

            var totalCountLabel = window.document.createElement("label");
            var startCount = chartUtils.format((pageIndex - 1) * pageSize + 1, ",.0f");
            var endCount = pageIndex * pageSize > totalRowCount ? formattedTotalRow : chartUtils.format(pageIndex * pageSize, ",.0f");
            totalCountLabel.innerHTML = " ( Items " + startCount + "-" + endCount + " of " + formattedTotalRow + " )";
            pageSizeContainer.appendChild(totalCountLabel);
        }

        // Remove the prev and next buttons if the Pagecount is one
        if (pageCount === 1) {
            d3.select('.pagination').select("a[pageindex='prev']").remove();
            d3.select('.pagination').select("a[pageindex='next']").remove();
        }

        function applyConditionalFormatting(field, td, value, d, pivotCategoryField, th) {
            var conditionalFormats = field.ConditionalFormatting;

            //Get pivot row object.
            if (pivotCategoryField != null) d = d[pivotItem[pivotCategoryField]];

            for (var cf = 0; cf < conditionalFormats.length; cf++) {
                var conditionalFormat = conditionalFormats[cf];
                var displayText = value == "" || value == null ? NaN : value;

                if (conditionalFormat.TableField != "--" && conditionalFormat.TableField != null) {
                    if (d.hasOwnProperty(conditionalFormat.TableField + "-" + field.HeaderName)) displayText = d[conditionalFormat.TableField + "-" + field.HeaderName] == null ? NaN : d[conditionalFormat.TableField + "-" + field.HeaderName];else if (d.hasOwnProperty(conditionalFormat.TableField)) displayText = d[conditionalFormat.TableField];else if (d.hasOwnProperty(fieldToHeaderMappingConditional[conditionalFormat.TableField])) displayText = d[fieldToHeaderMappingConditional[conditionalFormat.TableField]];else if (d.hasOwnProperty(field.HeaderName)) displayText = d[field.HeaderName];else displayText = NaN;
                }

                if (conditionalFormat.TargetProperty != null && conditionalFormat.TargetProperty != "--") {
                    if (d.hasOwnProperty(conditionalFormat.TargetProperty + "-" + field.HeaderName)) conditionalFormat.FormatValue = d[conditionalFormat.TargetProperty + "-" + field.HeaderName];else if (d.hasOwnProperty(conditionalFormat.TargetProperty)) conditionalFormat.FormatValue = d[conditionalFormat.TargetProperty];else if (d.hasOwnProperty(fieldToHeaderMappingConditional[conditionalFormat.TableField])) conditionalFormat.FormatValue = d[fieldToHeaderMappingConditional[conditionalFormat.TableField]];else if (d.hasOwnProperty(field.HeaderName)) conditionalFormat.FormatValue = d[field.HeaderName];else conditionalFormat.FormatValue = null;
                }

                if (pivotCategoryField != null && th != null && conditionalFormat.TableField != null && pivotCategoryField.toLowerCase() === conditionalFormat.TableField.toLowerCase()) {
                    if (pivotItem[pivotCategoryField].toString().toLowerCase() === conditionalFormat.FormatValue.toString().toLowerCase()) applyStyles(conditionalFormat.FormatOption, td);
                }

                var expression = chartUtils.buildFormatExpression(conditionalFormat, displayText);
                try {
                    if (eval(expression)) {
                        applyStyles(conditionalFormat.FormatOption, td);
                        break;
                    }
                } catch (ex) {
                    //Ignore exception & continue to next cell.
                }
            }
        }

        function applyStyles(formatOptions, td) {
            if (formatOptions != null && formatOptions.length > 0) {
                for (var fo = 0; fo < formatOptions.length; fo++) {
                    var formatOption = formatOptions[fo];
                    td.style.backgroundColor = formatOption.Fill;
                    td.style.borderColor = formatOption.BorderColor;
                    td.style.color = formatOption.ForegroundColor;
                }
            }
        }

        function isNumber(value) {
            value = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
            return !isNaN(Number(value));
        }

        function isTemporalField(fieldName) {
            if (fieldName == null) return;
            fieldName = fieldName.toLowerCase();
            return fieldName.indexOf('hour') >= 0 || fieldName.indexOf('day') >= 0 || fieldName.indexOf('date') >= 0 || fieldName.indexOf('year') >= 0 || fieldName.indexOf('quarter') >= 0 || fieldName.indexOf('month') >= 0;
        }
    };
    // Initiate rendering for a widget
    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
        // Get widget specific widgetConfig
        var widgetConfig = tableConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };

    return {
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default table();